import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=517bcbfa"
import script from "./Configurations.vue?vue&type=script&lang=js"
export * from "./Configurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports